let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j2OLf")).then(() => parcelRequire('gyMYQ'));